import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import './PlacePopup.css';

const PlacePopup = ({ place, isOpen, onRequestClose, onReserve }) => {
    const [currentImage, setCurrentImage] = useState('');

    useEffect(() => {
        if (place && place.imageUrls && Array.isArray(place.imageUrls)) {
            setCurrentImage(place.imageUrls[0]);
        }
    }, [place]);

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            contentLabel="Detalles del lugar"
            className="place-popup"
            overlayClassName="place-popup-overlay"
        >
            <h2>{place.nombreEspacio}</h2>
            <div className="place-popup-body">
                <div className="place-popup-image-container">
                    {currentImage && <img src={currentImage} alt={place.nombreEspacio} className="place-popup-main-image" />}
                </div>
                <p><strong>Máximo de personas:</strong> {place.maxPersonas}</p>
                <p><strong>Tipo:</strong> {place.tipo}</p>
                <div className="carousel">
                    {place.imageUrls && Array.isArray(place.imageUrls) && place.imageUrls.map((url, index) => (
                        <img
                            key={index}
                            src={url}
                            alt={`Extra ${index + 1}`}
                            className="carousel-image"
                            onClick={() => setCurrentImage(url)}
                        />
                    ))}
                </div>
            </div>
            <button onClick={onRequestClose} className="close-btn">Cerrar</button>
            <button onClick={onReserve} className="reserve-btn">Reservar</button>
        </Modal>
    );
};

export default PlacePopup;
